import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/auth-slice.js";
import menuesReducer from "./menu/menu-slice.js";
import notifsSlice from "./notifs/notifs-slice.js";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menues: menuesReducer,
    notifs: notifsSlice,
  },
});
